import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateTournament = (params) => {
    return axios.post(`${backendHost}/api/admin/tournament/update`, params);
};

export {
    postUpdateTournament
}